import React, {
  forwardRef,
  Ref,
  RefObject,
  useImperativeHandle,
  useState,
} from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearlocalStorage } from "../../utils/utils";
import { logout } from "../../services/services";

export interface LogoutMethod {
  open: () => void;
  close: () => void;
}

const Logout = ({}, ref: Ref<any>) => {
  const [state, setState] = useState({
    isOpen: false,
  });
  const updateState = (data: any) => setState((prev) => ({ ...prev, ...data }));
  const { isOpen } = state;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useImperativeHandle(
    ref,
    () => {
      return {
        open: () => {
          updateState({
            isOpen: true,
          });
        },
        close: close,
      };
    },
    []
  );

  const close = () => {
    updateState({
      isOpen: false,
    });
  };

  const onLogout = () => {
    logout().catch(err=>{})
    close();
    clearlocalStorage();
    dispatch({ type: "clearRedux" });
    navigate("/");
  };

  return (
    <Modal
      show={isOpen}
      onHide={close}
      centered
      contentClassName="logout-modal-content"
      backdropClassName="logout-modal-backdrop"
    >
      <Modal.Body className="text-center">
        <h5 className="fw-bold mb-3">Logout Confirmation</h5>
        <p className="text-muted mb-4">Are you sure you want to logout?</p>
        <div className="d-flex justify-content-center gap-3">
          <Button variant="primary" className="px-4" onClick={onLogout}>
            Confirm
          </Button>
          <Button variant="outline-primary" className="px-4" onClick={close}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default forwardRef(Logout);
